// Customer portal — entry.
//
// Finds the #app root and hands it to the chrome's mount(). Token parsing,
// branding, project fetch, section orchestration, error screens — all live
// under ./shell/.

import { mount } from "./shell";
import { mountInstallBanner } from "./shell/install-banner";
import { initPwa } from "./shell/pwa";
import "./style.css";
import "./shell/styles.css";

const root = document.getElementById("app");
if (!root) throw new Error("Missing #app root");

// Capture the browser's install prompt as early as possible — before the
// banner or the Account section mount — so both surfaces can offer install.
initPwa();

void mount(root);
mountInstallBanner();

// Service worker — register in production, unregister in dev so Vite HMR isn't
// masked by stale cached bundles (mirrors the retailer portal). Makes the
// customer portal installable (iOS Add-to-Home-Screen + Android/desktop prompt).
if ("serviceWorker" in navigator) {
  const isDev =
    import.meta.env.DEV || /(^|\.)(dev|stage|localhost)\b/.test(location.hostname);
  window.addEventListener("load", () => {
    if (isDev) {
      void navigator.serviceWorker
        .getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .then(() => {
          if ("caches" in window) {
            return caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
          }
          return undefined;
        })
        .catch(() => undefined);
    } else {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[sw] registration failed:", err);
      });
    }
  });
}
